import { create } from 'zustand';

// Mock data for sports
const sports = [
  { id: 'all', name: 'All', icon: 'LayoutGrid' },
  { id: 'basketball', name: 'Basketball', icon: 'Circle' },
  { id: 'soccer', name: 'Soccer', icon: 'Circle' },
  { id: 'tennis', name: 'Tennis', icon: 'Circle' },
  { id: 'running', name: 'Running', icon: 'Circle' },
  { id: 'swimming', name: 'Swimming', icon: 'Circle' },
  { id: 'cycling', name: 'Cycling', icon: 'Circle' },
  { id: 'yoga', name: 'Yoga', icon: 'Circle' },
];

// Mock data for featured events
const featuredEvents = [
  { 
    id: 1, 
    title: 'Weekend Basketball Pickup', 
    date: 'Sat, Dec 16 • 2:00 PM', 
    location: 'Central Park Court', 
    participants: 8, 
    maxParticipants: 12, 
    sport: 'basketball' 
  },
  { 
    id: 2, 
    title: 'Morning Running Group', 
    date: 'Sun, Dec 17 • 7:00 AM', 
    location: 'Riverside Trail', 
    participants: 15, 
    maxParticipants: 20, 
    sport: 'running' 
  },
  { 
    id: 3, 
    title: 'Tennis Doubles Match', 
    date: 'Mon, Dec 18 • 6:00 PM', 
    location: 'City Tennis Club', 
    participants: 3, 
    maxParticipants: 4, 
    sport: 'tennis' 
  },
];

// Mock data for nearby venues
const nearbyVenues = [
  { 
    id: 1, 
    name: 'Metro Sports Center', 
    sport: 'Multi-sport', 
    distance: '0.8 mi', 
    rating: 4.8 
  },
  { 
    id: 2, 
    name: 'Sunset Basketball Courts', 
    sport: 'Basketball', 
    distance: '1.2 mi', 
    rating: 4.5 
  },
  { 
    id: 3, 
    name: 'Aquatic Fitness Pool', 
    sport: 'Swimming', 
    distance: '2.1 mi', 
    rating: 4.7 
  },
];

// Mock data for recommended events
const recommendedEvents = [
  { 
    id: 4, 
    title: 'Soccer League Tryouts', 
    date: 'Tue, Dec 19 • 5:30 PM', 
    location: 'Community Sports Field', 
    participants: 18, 
    maxParticipants: 30, 
    sport: 'soccer' 
  },
  { 
    id: 5, 
    title: 'Evening Yoga Flow', 
    date: 'Wed, Dec 20 • 7:00 PM', 
    location: 'Zen Studio Downtown', 
    participants: 6, 
    maxParticipants: 15, 
    sport: 'yoga' 
  },
  { 
    id: 6, 
    title: 'Cycling Club Meetup', 
    date: 'Thu, Dec 21 • 6:00 AM', 
    location: 'Mountain View Trailhead', 
    participants: 12, 
    maxParticipants: 20, 
    sport: 'cycling' 
  },
  { 
    id: 7, 
    title: 'Swim Training Session', 
    date: 'Fri, Dec 22 • 6:00 PM', 
    location: 'Olympic Aquatic Center', 
    participants: 4, 
    maxParticipants: 8, 
    sport: 'swimming' 
  },
];

/**
 * Discovery Store - Manages discovery feed state
 * 
 * State:
 * - selectedSport: Currently selected sport filter
 * - sports: Available sport categories
 * - featuredEvents: Featured/promoted events
 * - nearbyVenues: Nearby venue suggestions
 * - recommendedEvents: Personalized recommendations
 * - hasNotification: Notification indicator state
 */
export const useDiscoveryStore = create((set, get) => ({
  // State
  selectedSport: 'all',
  sports,
  featuredEvents,
  nearbyVenues,
  recommendedEvents,
  hasNotification: true,

  // Actions
  setSelectedSport: (sportId) => set({ selectedSport: sportId }),
  
  toggleNotification: () => set((state) => ({ 
    hasNotification: !state.hasNotification 
  })),
  
  clearNotification: () => set({ hasNotification: false }),

  // Join event action (mock)
  joinEvent: (eventId) => {
    const state = get();
    const updatedFeatured = state.featuredEvents.map(event =>
      event.id === eventId && event.participants < event.maxParticipants
        ? { ...event, participants: event.participants + 1 }
        : event
    );
    const updatedRecommended = state.recommendedEvents.map(event =>
      event.id === eventId && event.participants < event.maxParticipants
        ? { ...event, participants: event.participants + 1 }
        : event
    );
    set({ 
      featuredEvents: updatedFeatured,
      recommendedEvents: updatedRecommended
    });
  },

  // Refresh data (mock)
  refreshData: () => {
    set({ isLoading: true });
    // Simulate API call
    setTimeout(() => {
      set({ isLoading: false });
    }, 500);
  },
}));

export default useDiscoveryStore;
